import { createAction } from '@reduxjs/toolkit';

import { createAPIActions } from 'utils/common';

import type { PickerFileMetadata } from 'filestack-js';
import type { PhotoUpload, CollectionName, PendingCollectionAction } from './photos.types';
import type { PickRequired } from 'types/common_types';

type PhotoUpdateParams = PickRequired<Partial<PhotoUpload>, 'id'>;

type UploadPhotosPayload = {
  uploads: PickerFileMetadata[];
  collection: string;
};

type SortPhotoPayload = {
  insertPhotoId: number;
  beforeIndex: number;
};

type RenameCollectionPayload = {
  current: CollectionName;
  change: string;
};

type CreateCollectionPayload = {
  name: string;
  action: PendingCollectionAction;
  donorIds: number[];
};

const getAll = createAPIActions<void, PhotoUpload[]>('photos', 'getAll');

const uploadPhotos = {
  pending: createAction<UploadPhotosPayload>('photos/uploadPhotos/pending'),
  fulfilled: createAction<PhotoUpload[]>('photos/uploadPhotos/fulfilled'),
  rejected: createAction('photos/uploadPhotos/rejected'),
};

const renameCollectionPhotos = createAPIActions<RenameCollectionPayload, PhotoUpload[]>(
  'photos',
  'renameCollectionPhotos'
);
const sortPhotos = createAction<SortPhotoPayload>('photos/sortPhotos');
const createNewCollection = createAction<CreateCollectionPayload>('photos/createNewCollection');
const moveUncollectedToCollection = createAction<string>('photos/moveUncollected');
const removeAllForCollection = createAction<string>('photos/removeAllForCollection');

const update = createAPIActions<PhotoUpdateParams, PhotoUpdateParams>('photos', 'update');

const removePhoto = createAPIActions<number, PhotoUpload>('photos', 'removePhoto');

const removeManyPhotos = {
  pending: createAction<number[]>('photos/removeManyPhotos/pending'),
  fulfilled: createAction<number[]>('photos/removeManyPhotos/fulfilled'),
  rejected: createAction('photos/removeManyPhotos/rejected'),
};

export default {
  getAll,
  uploadPhotos,
  renameCollectionPhotos,
  sortPhotos,
  createNewCollection,
  removePhoto,
  removeManyPhotos,
  removeAllForCollection,
  update,
  moveUncollectedToCollection,
};
